



























































helpers = require('../../helpers.coffee')

view_model = {
  props:
    user:
      type: User

    showCheckbox:
      default: false

    listCarousel:
      default: false

    userIsSelected:
      default: false

  data: ->
    current_user: Session.current_user
    show_form: false
    role_options: [
      { value: 'sdr', text: this.$t('users.role.sdr') }
      { value: 'seller', text: this.$t('users.role.seller') },
      { value: 'monitoring_manager', text: this.$t('users.role.monitoring_manager') },
      { value: 'manager', text: this.$t('users.role.manager') }
    ]
    new_email: null
    new_role: null

  computed:
    cant_update_user: ->
      (@user.role == @new_role && @user.email == @new_email) || (@new_role == null && @new_email == null)

    confirmed: ->
      return true if @user.name

      false

    user_name: ->
      if @user.name
        if @user.id == @current_user.id
          '#{@user.name} ' + this.$t('users.label.me')
        else
          @user.name
      else
        this.$t('users.label.guestPending')

    can_show_form: ->
      @current_user.isAdmin() || @current_user.isManager()

    selected: ->
      @userIsSelected

  methods:
    submit: ->
      @updateUser() unless @errors.has('email')

    setRole: (role) ->
      @new_role = role

    showForm: ->
      @show_form = !@show_form
      setTimeout(Tooltip.initialize, 500) if @show_form

    checkboxSelectUser: (user)  ->
      @$emit 'user-selected', user

    resendUserInvite: (user_id) ->
      Loader.on()
      new UsersResource().resendInviteUser(@updateUserResendInviteSuccess, @unknownError, { user_id: @user.id })

    updateUserResendInviteSuccess: (resource) ->
      Loader.off()
      alertify.success this.$t('users.actions.invite.resendSuccess')

    setParameters: ->
      params = {id: @user.id}
      if @new_role && @new_role != @user.role
        params["role"] = @new_role
      if @new_email && @new_email != @user.email
        params["email"] = @new_email

      return params

    updateUser: ->
      params = @setParameters()
      if @cant_update_user || (!params.hasOwnProperty("role") && !params.hasOwnProperty("email"))
        alertify.error this.$t('users.actions.error.changeEmail')
        return
      Loader.on()
      new UsersResource().update(@updateUserSuccess, @unknownError, params)

    updateUserSuccess: (resource) ->
      Loader.off()
      @trackIntercomEvent(resource)
      alertify.success this.$t('users.actions.update.success')
      @$emit('updated', resource.user)
      @show_form = false
      @new_email = null
      @new_role = null

    destroyUser: ->
      @$emit('destroy', @user)

    trackIntercomEvent: (resource) ->
      metadata = [
        { attribute: 'role', key: this.$t('users.attributes.role'), function: 'changedFromTo' },
        { key: 'id', value: resource.user.id },
        { key: this.$t('users.attributes.name'), value: resource.user.name },
        { key: this.$t('users.attributes.email'), value: resource.user.email },
      ]
      IntercomCtrl.trackEventMetadata(this.$t('users.actions.update.role'), metadata, {role: @user.role}, resource.user)
}

exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/users/list_item.vue